import React, { useState, useEffect } from "react";
import "./edituser.scss";
import Sidebar from "../Sidebar";
import { encode } from "base-64";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notify } from '../../services/notification';
import { HiMenu, HiX } from "react-icons/hi";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { RoleNameAction } from "../../actions/RoleAction";
import { CreateUserAction, UserNameAction, UpdateUserAction } from "../../actions/UserAction";
import { useParams } from "react-router-dom";
import { decode } from "base-64";
import { PHONE_NUMBER_REGEX } from "../../constants/regex/regex";
import useMobileView from "../../constants/useMobileView";


function EditUser() {
    const [loading, setloading] = useState(false);
    const { isSidebarOpen, toggleSidebar } = useMobileView();

    const [supervisers, setSupervisers] = useState([]);

    const [roleNames, setRoleNames] = useState([]);
    const { id } = useParams();
    const [states, setStates] = useState({
        name: "",
        email: "",
        role_id: "",
        reports_to_id: "",
        address: "",
        aps_code: "",
    })

    const handleInput = (e) => {
        let key = e.target.name;
        let value = e.target.value;
        if (key === "reports_to_id" || key === "role_id") {
            setStates({ ...states, [key]: Number(value) })
        }
        else if (key === "mobile_number") {
            validatePhoneNumber(value);
        }
        else {
            setStates({ ...states, [key]: value.replace(/^ +/gm, ""), })
        }
    }

    const validatePhoneNumber = (value) => {
        const numericValue = value.replace(/\D/g, "");
        if (numericValue === "" || PHONE_NUMBER_REGEX.test(value)) {
            setStates((prevState) => ({
                ...prevState,
                mobile_number: numericValue,
            }));
        }
    };

    const handleOnUpdateClick = async (e) => {
        e.preventDefault();
        setloading(true);
        if (!states.address) {
            delete states.address
        }
        if (!states.mobile_number) {
            delete states.mobile_number
        }
        let response = await dispatch(UpdateUserAction(states, decode(id)));
        if (response?.status === 200) {
            notify.success(response?.data?.message);
            setloading(false);
            navigate("/user")
        } else if (response?.status === 400) {
            setloading(false);
        }
        else if (response === undefined) {
            setloading(false);
        }
    }

    async function GetUserData() {
        var response = await dispatch(UserNameAction(decode(id)));
        if (response?.status === 200) {
            setStates({
                name: response?.data?.data[0]?.name,
                email: response?.data?.data[0]?.email,
                mobile_number: response?.data?.data[0]?.mobile_number,
                role_id: response?.data?.data[0]?.role,
                address: response?.data?.data[0]?.address,
                reports_to_id: response?.data?.data[0]?.reports_to?.id,
                aps_code: response?.data?.data[0]?.aps_code,
            });
        }
    }

    useEffect(() => {
        if (id) {
            GetUserData();
        }
    }, [id])



    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        GetRoleNameData()
    }, []);



    async function GetRoleNameData() {
        setloading(true);
        var response = await dispatch(RoleNameAction());
        if (response?.status === 200) {
            setloading(false);
            setRoleNames(response?.data?.results?.data)
            setSupervisers(response?.data?.results?.data);
        } else if (response === undefined) {
            setloading(false);
        }
    }

    return (
        <div className="edit-user-container">
            <div className="edit-user-containerright">
                <Header title="Edit User" />
                <div className="edit-user">
                    {loading ? (
                        <Loader />
                    ) : (
                        <form onSubmit={handleOnUpdateClick} className="form-div">
                            <div className="grid date">
                                <label className="label-edit-user">Full Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Enter Full Name"
                                    value={states.name}
                                    onChange={handleInput}
                                    className="edit-role-input-field"
                                    required
                                />
                            </div>
                            <div className="grid">
                                <label className="label-edit-user-address">APS Code</label>
                                <input
                                    type="text"
                                    name="aps_code"
                                    value={states.aps_code}
                                    onChange={handleInput}
                                    placeholder="Enter APS Code"
                                    className="edit-role-input-field"
                                    readOnly
                                />
                            </div>

                            <div className="grid">
                                <label className="label-edit-user">Login Id</label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Enter Login Id"
                                    value={states.email}
                                    onChange={handleInput}
                                    required
                                    className="edit-role-input-field"
                                />
                            </div>
                            <div className="grid">
                                <label className="label-edit-user-phone-number">Phone Number</label>
                                <input
                                    type="number"
                                    name="mobile_number"
                                    placeholder="Enter Phone Number "
                                    value={states.mobile_number}
                                    minLength={10}
                                    maxLength={10}
                                    onChange={handleInput}
                                    className="edit-role-input-field"
                                />
                            </div>
                            <div className="grid">
                                <label className="label-edit-user-address">Address</label>
                                <input
                                    type="text"
                                    name="address"
                                    value={states.address}
                                    onChange={handleInput}
                                    placeholder="Enter Address"
                                    className="edit-role-input-field"

                                />
                            </div>

                            <div className="grid">
                                <span className="label-edit-user"> Role</span>
                                <select className="text-filed-dropdown-user-management" required name="role_id" value={states.role_id} onChange={handleInput}>
                                    <option value="">Select Role</option>
                                    {roleNames?.length > 0 && roleNames?.map((data) => (
                                        <option key={data.id} value={data?.id}>
                                            {data?.role}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {/* // as per discussion with anjali below feature will go to next sprint */}
                            {/* <div className="grid">
                                <label className="label-edit-user">Reports to</label>
                            </div>
                            <div className="edit-role">
                                <div className="edit-role-checkbox-container">
                                    {
                                        supervisers.length > 0 && supervisers.map((val) =>
                                            <div className="edit-role-checkbox">
                                                <input className="creates-role-checkbox" type="radio" checked={states?.reports_to_id === val.id ? true : false} name="reports_to_id" value={val.id} onChange={handleInput} />
                                                <label className="creates-roles-label">{val?.role}</label>
                                            </div>
                                        )
                                    }
                                </div>
                            </div> */}
                            <div className="btn-notify">
                                <button
                                    onClick={() => {
                                        navigate("/user");
                                    }}
                                    className="user-active"
                                >
                                    Close
                                </button>
                                <button
                                    className="user-active"
                                    type="submit"
                                    disabled={!states.name || !states.email || !states.role_id}
                                >
                                    Update
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
export default EditUser;